import { useRootStore } from '~/store/root'
import { useUserStore } from '~/store/user'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const nuxtApp = useNuxtApp()
  const { $pinia, $lendioCookies } = nuxtApp

  const piniaUserStore = useUserStore($pinia)
  const piniaRootStore = useRootStore($pinia)

  const query = to.query
  // Called here to give access to env everywhere

  const oktaBaseUrl = useAffiliateCustomizationStore($pinia).oktaBaseUrl

  const logoutUrl = `${oktaBaseUrl}/oauth2/default/v1/logout?id_token_hint=${query.id}&post_logout_redirect_uri=${oktaBaseUrl}`

  if (query.id && !query.expired) {
    await piniaRootStore.setOktaId(query.id)
    await piniaUserStore.setAccessToken(query.at)
    await piniaUserStore.setFreshLogin('login')
    await piniaUserStore.getAuthToken()

    if (piniaRootStore.authToken && piniaRootStore.oktaId) {
      let redirectURI = query.redirect && decodeURIComponent(query.redirect)
      redirectURI = redirectURI || await $lendioCookies.get('redirect') || '/resume-app?login=true'

      return nuxtApp.runWithContext(() => navigateTo(redirectURI))
    } else {
      await piniaUserStore.setFreshLogin(null)

      return nuxtApp.runWithContext(() => navigateTo(logoutUrl, {external: true}))
    }
  } else if (query.id && query.expired) {
    return nuxtApp.runWithContext(() => navigateTo(logoutUrl, {external: true}))
  } else {
    await piniaRootStore.destroyUser()
    await piniaUserStore.clearAccessToken()
    return nuxtApp.runWithContext(() => navigateTo('/login-error'))
  }
})
